import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const ConfirmationDialog = ({
  open,
  onClose,
  onSubmit,
}: ConfirmationDialogProps) => (
  <Dialog
    onClose={onClose}
    open={open}
    sx={{
      '& .MuiDialog-container': {
        alignItems: 'flex-start',
      },
    }}
    PaperProps={{
      sx: {
        width: '100%',
        maxWidth: '604px',
      },
    }}
  >
    <DialogTitle
      sx={{
        paddingX: '24px',
        paddingTop: '24px',
        paddingBottom: '16px',
      }}
    >
      <FormattedMessage defaultMessage='Close Report Confirmation' />
    </DialogTitle>
    <DialogContent>
      <Typography color='#4F4F4F'>
        <FormattedMessage
          defaultMessage='Please confirm if you would like to close this report. Note that if any
        changes are needed later, you may need to request your administrator to
        reopen the case.'
        />
      </Typography>
    </DialogContent>
    <DialogActions
      sx={{
        padding: '24px',
      }}
    >
      <Button
        variant='outlined'
        color='inherit'
        sx={{
          textTransform: 'none',
          color: 'black',
          height: '42px',
          borderColor: '#D1D1D1',
          borderWidth: '1px',
        }}
        onClick={onClose}
      >
        <FormattedMessage defaultMessage='Cancel' />
      </Button>
      <Button
        variant='contained'
        color='blue'
        sx={{
          textTransform: 'none',
          height: '42px',
        }}
        disableElevation
        onClick={onSubmit}
      >
        <Typography fontSize={14} fontWeight={600}>
          <FormattedMessage defaultMessage='Close Report' />
        </Typography>
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmationDialog;
